<app-pageheader [Parent]="this">
  <add-button AddRoute="/valet/inventory/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="valet/inventory/searches"
  [AllowEdit]="true" EditUrl="/valet/inventory/:id" [UseQueryParamStates]="true">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-date-filter DateSearchProperty="StartDate"></div>
    <div app-valetstations-filter></div>
    <div app-subset-filter [Subsets]="Statuses" Subset="Open"></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>
